import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { OMDefaultsLayout } from "../Layouts";

function OMDefaultsTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
        props.omDefaultsFormLookupsLoad(formRefs);
    });
    const handleFieldChange = useCallback((name, value) => {
    
    }, []);
    const handleSelectionChange = useCallback((name, e) => {
       
    }, []);
    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='C02992DD-6980-452D-8C92-BC0C33979FA9'
            layoutName='CarrierOMDefaultsForm'
            defaultFormSchema={OMDefaultsLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OMDefaultsTab);